<template>
    <div id="root" class="root">
        <div v-show="loadHome" id="home" class="home">
            <div id="home-outer-wrapper" class="homeOuterWrapper">
                <div id="home-header" class="homeHeader">
                    <div id="home-search-wrapper" class="homeSearchWrapper">
                        <div id="home-logo" class="homeLogo">
                            <img
                                id="home-logo-img"
                                class="homeLogoImage"
                                :src="branding.logo"
                            />
                        </div>
                        <div id="home-input-wrapper" class="homeInputWrapper">
                            <auto-complete-input
                                v-model="query"
                                ref="queryInput"
                                id="home-input"
                                class="homeInput"
                                :group="currentGroupNumber || -1"
                                :placeholder="branding.AutocompletePlaceholder"
                                @selected="goToSerp()"
                                @return="goToSerp()"
                            />
                        </div>

                        <reordered-web-home
                            v-if="$features('reordered-links')"
                            @changeMode="changeMode"
                            @changeModeExternal="changeModeExternal"
                        ></reordered-web-home>

                        <div
                            id="home-header-navigation"
                            v-else
                            class="homeHeaderNavigation"
                        >
                            <div
                                v-for="(navItem, index) in viewList"
                                :key="index"
                                :id="`nav_${navItem.name}`"
                                class="navItem"
                                :class="{
                                    activeNavItem:
                                        currentMode.name == navItem.name,
                                }"
                                @click="changeMode(navItem)"
                            >
                                <img
                                    :id="`nav-icon_${navItem.name}`"
                                    class="navIcon"
                                    :src="navItem.icon"
                                />
                                <div
                                    :id="`nav-title_${navItem.name}`"
                                    class="navTitle"
                                >
                                    {{ navItem.name }}
                                </div>
                            </div>

                            <div
                                class="navItem yah"
                                :class="{
                                    activeNavItem: currentMode.name == 'images',
                                }"
                                @click="
                                    changeModeExternal(
                                        'images',
                                        `https://images.search.yahoo.com/yhs/search?p={{QUERY}}&type=${typeTag}`
                                    )
                                "
                            >
                                <a id="nav-link_images" class="navLink"></a>
                                <img
                                    id="nav-link_Images"
                                    src="/assets/images/common/icon_images.svg"
                                />
                                <div class="navTitle">
                                    Images
                                </div>
                            </div>

                            <div
                                class="navItem yah"
                                :class="{
                                    activeNavItem: currentMode.name == 'video',
                                }"
                                @click="
                                    changeModeExternal(
                                        'video',
                                        `https://video.search.yahoo.com/yhs/search?p={{QUERY}}&type=${typeTag}`
                                    )
                                "
                            >
                                <a id="nav-link_video" class="navLink"></a>
                                <img
                                    id="nav-link_Video"
                                    class="navLink"
                                    src="/assets/images/common/icon_video.svg"
                                />
                                <div class="navTitle">
                                    Video
                                </div>
                            </div>

                            <div
                                class="navItem yah"
                                :class="{
                                    activeNavItem:
                                        currentMode.name == 'shopping',
                                }"
                                @click="
                                    changeModeExternal(
                                        'shopping',
                                        `https://shopping.yahoo.com/search?p={{QUERY}}&type=${typeTag}`
                                    )
                                "
                            >
                                <a id="nav-link_shopping" class="navLink"></a>
                                <img
                                    id="nav-link_Shopping"
                                    class="navLink"
                                    src="/assets/images/common/icon_shopping.svg"
                                />
                                <div class="navTitle">
                                    Shopping
                                </div>
                            </div>

                            <div
                                class="navItem yah"
                                :class="{
                                    activeNavItem: currentMode.name == 'news',
                                }"
                                @click="
                                    changeModeExternal(
                                        'news',
                                        `https://news.search.yahoo.com/search?p={{QUERY}}&type=${typeTag}`
                                    )
                                "
                            >
                                <a id="nav-link_news" class="navLink"></a>
                                <img
                                    id="nav-link_News"
                                    class="navLink"
                                    src="/assets/images/common/icon_news.svg"
                                />
                                <div class="navTitle">
                                    News
                                </div>
                            </div>

                            <div
                                id="yahoo-links-more"
                                class="navItem more dropdown"
                            >
                                <a
                                    id="nav-link_more"
                                    class="navLink dropbtn"
                                    href="#"
                                >
                                    <img
                                        id="nav-link_More"
                                        class="navLink"
                                        src="/assets/images/common/icon_more.svg"
                                    />
                                    More</a
                                >
                                <div class="dropdown-content">
                                    <a
                                        @click="
                                            changeModeExternal(
                                                'images',
                                                `https://images.search.yahoo.com/yhs/search?p={{QUERY}}&type=${typeTag}`
                                            )
                                        "
                                        ><img
                                            class="moreLink"
                                            :class="{
                                                activeNavItem:
                                                    currentMode.name ==
                                                    'images',
                                            }"
                                            src="/assets/images/common/icon_images.svg"
                                        />Images</a
                                    >
                                    <a
                                        @click="
                                            changeModeExternal(
                                                'video',
                                                `https://video.search.yahoo.com/yhs/search?p={{QUERY}}&type=${typeTag}`
                                            )
                                        "
                                        ><img
                                            class="moreLink"
                                            :class="{
                                                activeNavItem:
                                                    currentMode.name == 'video',
                                            }"
                                            src="/assets/images/common/icon_video.svg"
                                        />Videos</a
                                    >
                                    <a
                                        @click="
                                            changeModeExternal(
                                                'shopping',
                                                `https://shopping.yahoo.com/search?p={{QUERY}}&type=${typeTag}`
                                            )
                                        "
                                        ><img
                                            class="moreLink"
                                            :class="{
                                                activeNavItem:
                                                    currentMode.name ==
                                                    'shopping',
                                            }"
                                            src="/assets/images/common/icon_shopping.svg"
                                        />Shopping</a
                                    >
                                    <a
                                        @click="
                                            changeModeExternal(
                                                'news',
                                                `https://news.search.yahoo.com/search?p={{QUERY}}&type=${typeTag}`
                                            )
                                        "
                                        ><img
                                            class="moreLink"
                                            :class="{
                                                activeNavItem:
                                                    currentMode.name == 'news',
                                            }"
                                            src="/assets/images/common/icon_news.svg"
                                        />News</a
                                    >
                                </div>
                            </div>
                        </div>
                        <!-- end of nav-->
                    </div>
                </div>
                <div
                    v-if="
                        activeStoryBlockList && activeStoryBlockList.length > 0
                    "
                    id="home-body"
                    class="homeBody"
                >
                    <div class="home-body-left">
                        <div id="hero-wrapper" class="heroWrapper">
                            <hero-block
                                v-if="
                                    heroStory &&
                                        heroStory.story &&
                                        heroStory.category
                                "
                                :story="heroStory.story"
                                :category="heroStory.category"
                            ></hero-block>
                        </div>
                        <div id="news-wrapper" class="newsWrapper">
                            <div
                                v-if="
                                    activeStoryBlockList &&
                                        activeStoryBlockList.length > 0
                                "
                                id="news-block-inner-wrapper"
                                class="newsBlockInnerWrapper"
                                :key="newsKey"
                            >
                                <div
                                    v-for="(storyList,
                                    index) in activeStoryBlockList"
                                    :key="index"
                                    id="news-block"
                                    class="newsBlock"
                                >
                                    <story-block
                                        :category="storyList.name"
                                        :storyList="storyList.storyList"
                                        :fullStoryMode="fullStoryMode"
                                    ></story-block>
                                    <!-- only load ads on initial block and not other ones loaded later -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="home-body-right">
                        <div id="weather-wrapper" class="weatherWrapper">
                            <weather-block
                                v-if="weatherData && weatherData.data"
                                :weatherData="weatherData.data"
                            ></weather-block>
                        </div>
                        <div id="sticky-sidebar">
                            <div
                                v-if="feedCategories"
                                id="select-news-categories-wrapper"
                                class="selectNewsCategoriesWrapper newsBlock"
                            >
                                <span class="topSectionTitle">News Feeds</span>
                                <div
                                    v-for="(name, index) in feedCategories"
                                    :key="index"
                                    :id="`newsCategorySelector_${name}`"
                                    class="categorySelector"
                                >
                                    <input
                                        type="checkbox"
                                        :id="`news-category-checkbox_${name}`"
                                        class="newsCategoryCheckbox"
                                        :value="name"
                                        v-model="activeStoryCategories"
                                    />
                                    <label
                                        class="newsCategoryCheckboxLabel"
                                        :class="{
                                            activeNewsCategoryCheckboxLabel: activeStoryCategories.includes(
                                                name
                                            ),
                                        }"
                                        :for="`news-category-checkbox_${name}`"
                                        >{{ titleCase(name) }}</label
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="homeFooter" class="homeFooter">
                    <freshy-footer />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from "query-string";
import { verticalList, defaultVertical } from "@/linkLists";
import { YAHOO_COBRAND_URL } from "@/urls";
import FreshyFooter from "@/components/footer/Footer.vue";
import AutoCompleteInput from "@/components/autoCompleteInput/AutoCompleteInput.vue";
import { pageviewEvent, searchEvent, clickEvent, trackGA } from "@/analytics";
import { getBranding } from "@/branding";
import { documentReady, setSearchHistory } from "@/common";
import home from "../common/mixins/home";
import HeroBlock from "../common/components/heroBlock";
import WeatherBlock from "../common/components/weatherBlock";
import StoryBlock from "../common/components/storyBlock";
import ReorderedWebHome from "./WebReorderedHome.vue";

export default {
    mixins: [home],
    components: {
        "freshy-footer": FreshyFooter,
        "auto-complete-input": AutoCompleteInput,
        "story-block": StoryBlock,
        "weather-block": WeatherBlock,
        "hero-block": HeroBlock,
        "reordered-web-home": ReorderedWebHome,
    },
    data() {
        const qs = queryString.parse(window.location.search);
        return {
            currentMode: defaultVertical,
            searchParams: qs || null,
            query: qs.q || null,
            typeTag: qs.type || null,
            guid: qs.guid || null,
            viewList: verticalList,
            branding: getBranding(),
            fullStoryMode: false,
            activeStoryCategories: [],
            newsKey: 0,
            heroStory: null,
            loadHome: false,
        };
    },
    mounted() {
        this.initConsent();
        if (this.query) {
            const queryParams = this.getQueryParameters();
            if (queryParams && queryParams.q) {
                const newUrl = `/web?${queryString.stringify(queryParams)}`;
                window.open(
                    newUrl,
                    window.self !== window.top ? "_parent" : "_self"
                );
                return;
            }
        }
        this.loadHome = true;

        document.title = "Freshy";
        pageviewEvent(null, null, this.typeTag);
        const feedPromise = this.getAllFeeds();

        documentReady.then(async () => {
            document.addEventListener("keydown", event => {
                if (event.key.match(/(\w|\s)/g) && event.key.length == 1) {
                    document.querySelector("#auto-complete-input").focus();
                }
            });

            // redirect if q parameter is present
            if (this.searchParams && this.searchParams.q) {
                window.location.href = `/web?${queryString.stringify(
                    this.searchParams
                )}&type=xml`;
            }

            await feedPromise;
            this.initNewsFeeds();
            await this.addStories(false);
            this.heroStory = this.getHeroStory();
        });
    },
    computed: {
        currentGroupNumber() {
            return this.currentMode.group;
        },
        topStories() {
            if (this.newsFeeds && this.newsFeeds["top news"])
                return this.newsFeeds["top news"].splice(0, 5);
            return null;
        },
        filteredNewsFeeds() {
            if (
                this.newsFeeds &&
                (!this.activeStoryCategories ||
                    this.activeStoryCategories.length == 0)
            )
                return this.newsFeeds;
            if (
                this.newsFeeds &&
                this.activeStoryCategories &&
                this.activeStoryCategories.length > 0
            ) {
                const feeds = {};
                for (const i in this.activeStoryCategories)
                    if (this.newsFeeds[this.activeStoryCategories[i]]) {
                        feeds[this.activeStoryCategories[i]] = this.newsFeeds[
                            this.activeStoryCategories[i]
                        ];
                    }
                return feeds;
            }
            return null;
        },
    },
    watch: {
        async activeStoryCategories() {
            document.querySelector("#root").scrollTo(0, 0);
            this.activeStoryBlockList = [];
            this.storyBlockList = [];
            this.activeBlockStart = 0;

            if (this.activeStoryCategories.length == 0) {
                this.fullStoryMode = false;
                this.activeBlockStoryCount = 7;
                this.activeBlockAddSize = 3;
            } else {
                this.fullStoryMode = true;
                this.activeBlockStoryCount = 3;
                this.activeBlockAddSize = 5;
            }
            await this.addStories(false);
            this.newsKey++;
        },
    },
    updated() {
        this.$nextTick(() => {
            /* refreshAds() */
        });
    },
    methods: {
        async addStories(shuffle = true, secondRun = false) {
            if (this.filteredNewsFeeds && this.filteredNewsFeeds != {}) {
                const currentLength = this.storyBlockList.length;
                if (
                    this.storyBlockList &&
                    currentLength > 0 &&
                    this.activeBlockStart + this.activeBlockAddSize <
                        currentLength
                ) {
                    const newList = this.storyBlockList.slice(
                        this.activeBlockStart,
                        this.activeBlockStart + this.activeBlockAddSize
                    );
                    this.activeStoryBlockList = this.activeStoryBlockList.concat(
                        newList
                    );
                    this.activeBlockStart += this.activeBlockAddSize;
                } else if (!secondRun) {
                    this.addToBlockList(shuffle);
                    await this.addStories(true, true);
                }
            }
        },
        changeMode(mode) {
            this.currentMode = mode;
            clickEvent(
                null,
                `Home Page Vertical Click`,
                this.currentMode.name,
                this.typeTag
            );
        },
        changeModeExternal(label, path) {
            this.currentMode = { external: true, name: label, path };
        },
        getQueryParameters() {
            const out = {};
            if (this.query) out.q = this.query;
            if (this.typeTag) out.type = this.typeTag;
            if (this.guid) out.guid = this.guid;

            return out;
        },
        async goToSerp() {
            if (this.query && this.currentMode) {
                setSearchHistory(this.query, this.currentMode.name);
            }
            if (
                this.query &&
                this.currentMode.external &&
                this.currentMode.path
            ) {
                const newUrl = this.currentMode.path.replace(
                    "{{QUERY}}",
                    this.query
                );
                window.open(newUrl, "_blank");
            } else if (this.query && this.currentMode.path) {
                let newUrl = `${this.currentMode.path}`;
                const queryParams = this.getQueryParameters();
                if (queryParams)
                    newUrl += `?${queryString.stringify(queryParams)}`;
                try {
                    await this.sendMessageToExt({
                        task: "search",
                        value: this.query,
                    });
                } catch (e) {
                    window.open(
                        newUrl,
                        window.self !== window.top ? "_parent" : "_self"
                    );
                }
            }
        },
        addScrollListener() {
            const root = document.querySelector("#root");

            const scrollEv = () => {
                // OFFSET TO TRIGGER, HAVE SET TO OFFSET HEIGHT
                const OFFSET = root.offsetHeight;

                if (
                    root.scrollTop >=
                    root.scrollHeight - (root.offsetHeight + OFFSET)
                ) {
                    this.addStories();
                } else if (
                    root.scrollTop >=
                    root.scrollHeight - (root.offsetHeight + OFFSET / 2)
                ) {
                }
            };

            try {
                root.removeEventListener("scroll", scrollEv);
            } catch (e) {
                console.error("ERROR SCROLL: ", e);
            }
            // Add load on scroll

            root.addEventListener("scroll", scrollEv);
        },
        initNewsFeeds() {
            if (this.newsFeeds) {
                this.addToBlockList();
                this.addScrollListener();
            }
        },
        initConsent() {
            if (this.searchParams && this.searchParams.rdr) {
                window.consentConfig = {
                    descText: "Continue with Freshy Homepage",
                    logo: "/assets/images/common/freshy_logo.png",
                    apiDomain: "https://api.freshyrecipes-api.com",
                };

                const script = document.createElement("script");
                script.src = "/consent/assets/consent-freshy.js";
                script.setAttribute("async", null);
                document.body.appendChild(script);
            }
        },
    },
};
</script>

<style scoped src="./home.css"></style>
